import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { BoostModalData } from '../types';

type BoostModalProviderProps = {
  children: ReactNode;
};

type BoostModalContextValue = {
  isBoostModalOpen: boolean;
  setIsBoostModalOpen: (open: boolean) => void;
  boostModalData: BoostModalData | undefined;
  setBoostModalData: (data: BoostModalData | undefined) => void;
  selectedBundle?: number;
  setSelectedBundle: (bundleID: number | undefined) => void;
};

const BoostModalContext = createContext<BoostModalContextValue>({
  isBoostModalOpen: false,
  setIsBoostModalOpen: () => null,
  boostModalData: undefined,
  setBoostModalData: () => null,
  selectedBundle: undefined,
  setSelectedBundle: () => null,
});

const BoostModalProvider = ({ children }: BoostModalProviderProps) => {
  const [isBoostModalOpen, setIsBoostModalOpen] = useState<boolean>(false);
  const [boostModalData, setBoostModalData] = useState<
    BoostModalData | undefined
  >(undefined);
  const [selectedBundle, setSelectedBundle] = useState<number | undefined>(
    undefined,
  );

  const value = useMemo(
    () => ({
      isBoostModalOpen,
      setIsBoostModalOpen,
      boostModalData,
      setBoostModalData,
      selectedBundle,
      setSelectedBundle,
    }),
    [isBoostModalOpen, boostModalData, selectedBundle],
  );

  return (
    <BoostModalContext.Provider value={value}>
      {children}
    </BoostModalContext.Provider>
  );
};

const useBoostModal = () => useContext(BoostModalContext);

export { BoostModalProvider, useBoostModal };
